module.exports = __webpack_public_path__ + "img/wi-fi-no.3bbb6e00.svg";